// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4827) return "static/chunks/4827-821159e3900f5741.js";
	if (chunkId === 9346) return "static/chunks/9346-072c73cd389a0414.js";
	if (chunkId === 3329) return "static/chunks/3329-3407cbe14b1ffffd.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"704":"bf3f768e7483665c","2740":"dca0edd8ec7855d6","5652":"92ad00973b3f4dc3"}[chunkId] + ".js";
};